import { useState } from "react";
import { Radio } from "lucide-react";
import { toast } from "sonner";
import { isAuthed } from "@/lib/auth";

const GoLiveToggle = ({ initial = false, onChange }) => {
  const [live, setLive] = useState(initial);

  const handle = () => {
    if (!isAuthed()) {
      window.dispatchEvent(new CustomEvent("grabb:friction", { detail: { action: "go_live" } }));
      return;
    }
    const next = !live;
    setLive(next);
    onChange?.(next);
    toast.success(next ? "You're live now" : "You're offline");
  };

  return (
    <button
      onClick={handle}
      className={`w-full brutal-border rounded-2xl brutal-shadow p-5 flex items-center justify-between transition-colors ${
        live ? "bg-[#FF6A2C] text-white" : "bg-white text-[#0A0A0A]"
      }`}
      data-testid="go-live-toggle"
    >
      <div className="flex items-center gap-3">
        <div className={`w-12 h-12 rounded-full brutal-border flex items-center justify-center ${live ? "bg-white text-[#FF6A2C]" : "bg-[#F8F9FA]"}`}>
          {live ? (
            <span className="relative flex h-3 w-3">
              <span className="live-ping absolute inline-flex h-full w-full rounded-full bg-[#FF6A2C] opacity-75" />
              <span className="relative inline-flex rounded-full h-3 w-3 bg-[#FF6A2C]" />
            </span>
          ) : (
            <Radio className="w-5 h-5" />
          )}
        </div>
        <div className="text-left">
          <div className="font-heading font-black text-xl leading-none">{live ? "LIVE NOW" : "GO LIVE"}</div>
          <div className={`text-xs mt-1 ${live ? "text-white/80" : "text-[#555555]"}`}>
            {live ? "Broadcasting availability — tap to stop" : "Broadcast you're up for something"}
          </div>
        </div>
      </div>
      <div className={`w-14 h-8 rounded-full brutal-border relative ${live ? "bg-white" : "bg-[#F8F9FA]"}`}>
        <span
          className={`absolute top-0.5 w-6 h-6 rounded-full brutal-border transition-all ${
            live ? "left-7 bg-[#FF6A2C]" : "left-0.5 bg-white"
          }`}
        />
      </div>
    </button>
  );
};

export default GoLiveToggle;
